import { StyledLogo } from "./styles"

const LogoDark = () => {
  return <StyledLogo src={process.env.PUBLIC_URL + "/res/img/poweredBy8thWall.png"} />
}

export default LogoDark;
